import { FC } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { SearchFilter } from '@mobileTypes'
import { Box, IconButton, Paper, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

interface ConfiguredFiltersPanelProps {
  filters: SearchFilter[]
  onEdit: (index: number) => void
  onDelete: (index: number) => void
}

export const ConfiguredFiltersPanel: FC<ConfiguredFiltersPanelProps> = ({
  filters,
  onEdit,
  onDelete,
}) => {
  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Configured Filters
      </Typography>
      <Droppable droppableId='FILTERS'>
        {provided => (
          <Box
            ref={provided.innerRef}
            {...provided.droppableProps}
            sx={{
              minHeight: 200,
              p: 1,
              border: '2px dashed',
              borderColor: 'divider',
              borderRadius: 1,
            }}
          >
            {filters.length === 0 ? (
              <Typography variant='body2' color='text.secondary' sx={{ textAlign: 'center', py: 4 }}>
                Drag filters here to configure
              </Typography>
            ) : (
              filters.map((filter, index) => (
                <Draggable key={filter.id} draggableId={filter.id} index={index}>
                  {(provided, snapshot) => (
                    <Paper
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      sx={{
                        p: 2,
                        mb: 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        opacity: snapshot.isDragging ? 0.5 : 1,
                        bgcolor: snapshot.isDragging ? 'action.selected' : 'background.paper',
                      }}
                    >
                      <Box {...provided.dragHandleProps} sx={{ display: 'flex', cursor: 'grab' }}>
                        <DragIndicatorIcon />
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant='body1' fontWeight='bold'>
                          {filter.label}
                        </Typography>
                        <Typography variant='caption' color='text.secondary'>
                          {filter.type} - {filter.fieldCode} {filter.operator}
                        </Typography>
                      </Box>
                      <IconButton size='small' onClick={() => onEdit(index)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton size='small' color='error' onClick={() => onDelete(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </Paper>
                  )}
                </Draggable>
              ))
            )}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Box>
  )
}





